module.exports = __webpack_public_path__ + "img/18.fb05063d.jpg";